/**
 * What the user says in the general chat to ask for a plan change, in first
 * person. `from` is the plan they have (with its period), `to` the one they want;
 * without a known current plan it only names the target.
 */
export const planChangeMessage = ({ from, to }: { from?: string | null; to: string }): string =>
	from ? `Hola, quiero cambiar mi plan de ${from} a ${to}.` : `Hola, quiero cambiar mi plan a ${to}.`;
